import React from 'react'
import styled from '@emotion/styled';
import { green01, pcHeaderH, fontEn, fontHiraginoKakugo , text, mq, gray01, grayBg, baseDurationTime } from '../../_style';
import PageMain from '../../components/organisms/pageMain';
import imgMain from '../../assets/imgs/about/img-main.jpg';
import imgMainSp from '../../assets/imgs/about/sp/img-main.jpg';
import InnerLinkGroup from '../../components/molecules/about/innerLinkGroup';
import AboutBox from '../../components/organisms/about/aboutBox';
import Br from '../../components/atoms/br';
import Image from '../../components/atoms/image';
import Text from '../../components/atoms/text';
import Caption from '../../components/atoms/caption';
import SubHeading from '../../components/atoms/subHeading';
import TextBlock from '../../components/molecules/textBlock';
import ContentWidth from '../../components/organisms/contentWidth';
import SectionLineup from '../../components/organisms/sectionLineup';
import { Helmet } from 'react-helmet';
import InViewWrapper from '../../components/organisms/inViewWrapper';

const Container = styled.div`
`
const AboutContents = styled.section`
  background-color: ${grayBg};
  margin-bottom: 120px;
  padding-top: 120px;
  padding-bottom: 120px;
  ${mq.sp} {
    margin-bottom: 60px;
    padding: 60px 0;
  }
  & > h3 {
    color: ${green01};
    padding-bottom: 60px;
    ${text('36px', 60 / 36)}
    letter-spacing: 0.16em;
    text-align: center;
    ${mq.sp} {
      padding-bottom: 40px;
      ${text('26px', 80 / 52)}
    }
    & > span {
      display: inline-block;
      ${text('72px', 60 / 72)}
      font-family: ${fontHiraginoKakugo};
      font-weight: 200;
      vertical-align: bottom;
      ${mq.sp} {
        ${text('60px', 80 / 60)}
        vertical-align: middle;
      }
    }
  }
`
const AboutContent = styled.div`
  ${mq.pc} {
    display: flex;
    justify-content: space-between;
    ${props => props.isImgLeft && 'flex-direction: row-reverse;'}
  }
  ${mq.sp} {
    & + * {
      margin-top: 20px;
    }
  }
`

const AboutContentNum = styled.div`
  margin-bottom: 34px;
  color: ${green01};
  font-family: ${fontEn};
  font-weight: 700;
  font-size: 46px;
  line-height: 0.8;
  letter-spacing: 0.05em;
`
const AboutContentTexts = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 68px;
  background-color: #fff;
  ${mq.pc} {
    width: 50%;
  }
  ${mq.sp} {
    padding: 30px;
  }
  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    transform: scale3d(1, 1, 1);
    transform-origin: right;
    transition: transform ${parseFloat(baseDurationTime) * 2.5}s ease;
    will-change: transform;
    .is-shown & {
      transform: scale3d(0, 1, 1);
    }
  }
`
const AboutContentTitle = styled.div`
  margin-bottom: 37px;
`
const AboutContentImage = styled.div`
  ${mq.pc} {
    width: 50%;
  }
`

const About = (props) => {
  return(
    <Container>
      <Helmet
        title="モンダミンについて | モンダミン | アース製薬"
        meta={[
            { name: 'description', content: 'モンダミンは「日本人が毎日使いたくなるような洗口液」をコンセプトに198年に誕生して以来、常に進化し続けています。モンダミンのロングセラーの秘密である3つのこだわりをご紹介します。'},
            { name: 'keywords', content: 'モンダミン,もんだみん,mondahmin,オーラルケア,アース製薬' }
        ]}
      ></Helmet>
      <PageMain bg={imgMain} bgSp={imgMainSp} en={'ABOUT'}>モンダミンについて</PageMain>
      <AboutBox>日本でまだ洗口液が一般的ではなかった1987年、モンダミンは「日本人が毎日使いたくなるような洗口液」をコンセプトに誕生しました。<br />その思いは発売から30年が経った現在も変わらず、おいしさにこだわり、様々な年代のお口の悩みに合わせた製品開発を行っています。</AboutBox>
      <AboutContents>
        <h3>モンダミンだからできる<Br /><span>4</span>つのこと</h3>
        <ContentWidth>
          <InViewWrapper>
            <AboutContent>
              <AboutContentTexts>
                <AboutContentNum>01</AboutContentNum>
                <AboutContentTitle><SubHeading>お⼝の悩みに合わせた<Br />豊富なラインナップ</SubHeading></AboutContentTitle>
                <Text>お子様から高齢者の方まで。豊富なラインナップの中から、レギュラータイプ、プレミアムケアタイプ、専用ケアタイプ、子ども用と様々なお口の悩みに合わせて、最適な1本をお選びいただけます。</Text>
              </AboutContentTexts>
              <AboutContentImage>
                <Image filename={'about/img-01.jpg'}></Image>
              </AboutContentImage>
            </AboutContent>
          </InViewWrapper>
          <InViewWrapper>
            <AboutContent isImgLeft>
              <AboutContentTexts>
                <AboutContentNum>02</AboutContentNum>
                <AboutContentTitle><SubHeading>日本人好みの香味</SubHeading></AboutContentTitle>
                <Text>開発当時、最後までこだわったのは日本人が習慣として受け入れてくれるようなおいしい香味でした。そのこだわりは現在の製品開発にも受け継がれており、効果を実感できるようなおいしい香味や使用感に仕上げています。</Text>
              </AboutContentTexts>
              <AboutContentImage>
                <Image filename={'about/img-02.jpg'}></Image>
              </AboutContentImage>
            </AboutContent>
          </InViewWrapper>
          <InViewWrapper>
            <AboutContent>
              <AboutContentTexts>
                <AboutContentNum>03</AboutContentNum>
                <AboutContentTitle><SubHeading>お口の「よごれ」を<Br />しっかり落とす洗浄力</SubHeading></AboutContentTitle>
                <Text>日本人のお口を守るために。モンダミンは歯垢、口臭などお口のトラブルの原因となる「よごれ」の洗浄に注目しました。しっかり洗浄し、すっきり清潔にすることでお口の健康を守ります。</Text>
              </AboutContentTexts>
              <AboutContentImage>
                <Image filename={'about/img-03.jpg'}></Image>
              </AboutContentImage>
            </AboutContent>
            </InViewWrapper>
          <InViewWrapper>
            <AboutContent isImgLeft>
              <AboutContentTexts>
                <AboutContentNum>04</AboutContentNum>
                <AboutContentTitle><SubHeading>お口、クチュ、クチュ。<br />すすぐだけ<sup>＊</sup></SubHeading></AboutContentTitle>
                <TextBlock>
                  <Text>日本に洗口液文化を普及するために。おなじみの「お口、クチュ、クチュ。」のフレーズは「お口に含んで、すすいでから吐き出す」という洗口液の使い方を表現しています。ハミガキの仕上げやお口の不快感が気になった時など、お手軽にお使いいただけます。</Text>
                  <Caption>＊液体ハミガキ、液状ハミガキにはブラッシングが必要です。</Caption>
                </TextBlock>
              </AboutContentTexts>
              <AboutContentImage>
                <Image filename={'about/img-04.jpg'}></Image>
              </AboutContentImage>
            </AboutContent>
          </InViewWrapper>
          <InnerLinkGroup path={props.path}></InnerLinkGroup>
        </ContentWidth>
      </AboutContents>
      <SectionLineup></SectionLineup>
    </Container>
  );
}
export default About
